<n-slide-window id="create_DataTurbo_share_slidewindow"
    *ngIf="pageReady"
    [visible]="windowVisible"
    width="7rem"
    [loading]="loading"
    (onHide)="close()">
    <n-header>
        <h1>{{createAsShare? i18n.title.createAsTitle : title}}</h1>
        <n-help-link [key]="createAsShare? 'DataTurboCopy' : 'DataTurboCreate'"></n-help-link>
        <n-checkbox *ngIf="!slideWindow?.showBatch"
            id="create-data-turbo-share_advanced"
            style="margin-left: auto;"
            [label]="i18n.label.advance"
            [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <n-block [title]="i18n.title.basicInfo">
        <form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
            <!-- 所属租户 -->
            <n-form-item [label]="i18n.label.vStoreLab">
                <div id="create-data-turbo-share-vstore" class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- 文件系统 -->
            <n-form-item [label]="i18n.label.fileSystem" [required]="canFileSystemChange">
                <div class="interval-10 custom-width"
                    *ngIf="canFileSystemChange; else fsText">
                    <n-select #fsSelect
                        id="create-data-turbo-share-fs"
                        [rest]="fileSystemRest"
                        [valueField]="'ID'"
                        [labelField]="'NAME'"
                        [filter]="true"
                        formControlName="filesystem"
                        (onChange)="onChooseFileSystem($event)">
                    </n-select>
                </div>
                <ng-template #fsText>
                    <div class="n-form-item-text">{{fileSystem?.name || fileSystem?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
            </n-form-item>
            <!-- dtree -->
            <n-form-item *ngIf="showDtree && hasDtreePermission" [label]="i18n.label.dtree">
                <n-select id="create-nfs-share-fs"
                    *ngIf="canDtreeChange; else dtreeText"
                    [rest]="dtreeRest"
                    [valueField]="'ID'"
                    [labelField]="'NAME'"
                    [filter]="!!dtreeRest"
                    formControlName="dtree"
                    [clearBtn]="true"
                    (onChange)="onChooseDtree($event)">
                </n-select>
                <ng-template #dtreeText>
                    <div class="text-wrap n-form-item-text">{{dtree?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
                <n-tip type="warning" *ngIf="dtreePathHasBackslash"
                    [content]="i18n.tip.dtreePathHasBackslash">
                </n-tip>
            </n-form-item>
            <!-- 共享路径，只展示 -->
            <n-form-item [required]="false" [label]="i18n.label.share_path">
                <n-inline-loading *ngIf="pathLoading" state="loading"></n-inline-loading>
                <div *ngIf="!pathLoading"
                    id="create-data-turbo-share-share_path"
                    class="text-wrap n-form-item-text">
                    {{share_path || UNPLACEHOLDER}}
                </div>
            </n-form-item>

            <!-- 高级选项 -->
            <ng-container *ngIf="advanced">
                <!-- 描述 -->
                <n-form-item [label]="i18n.label.description">
                    <textarea id="create-data-turbo-share-description"
                        nTextarea
                        formControlName="description"
                        [placeholder]="errorMessage.description.rangeByteLength">
                    </textarea>
                </n-form-item>
            </ng-container>
        </form>
    </n-block>
    <!-- 权限列表 -->
    <n-block [title]="i18n.title.permissionList"
        class="clients-tip">
        <n-loading  [visible]="allUserLoading"></n-loading>
        <p class="mb-10">{{i18n.tip.clientsTip}}</p>
        <app-front-table-data-turbo-user-share
            [supportSmartGui]="supportSmartGui"
            [isCopyFrom]='!!copyFromStyle'
            [(tableData)]="permissionList"
            [selectFs]="selectedFilesystem"
            (clickAddBtn)="onClickAddBtn()"
            [vstoreId]="vstoreId"
            [vstoreName]="vstoreName"
            [entry]="entry">
        </app-front-table-data-turbo-user-share>
    </n-block>
    <n-footer>
        <button id="create-data-turbo-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="create-data-turbo-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
